module.exports = __webpack_public_path__ + "static/media/Submarine.9430b123.mp3";